<div class="rs-wrapper-v4">
    <h2>{{ 'subtitle_one' | translate }}</h2>
    <h5>{{ 'subtitle_two' | translate }}</h5>
    <rs-carousel [animationTime]="5">
        <app-help-options *ngFor="let item of aboutUsMissionsAndValues" [elementsHelpOptions]="item"></app-help-options>
    </rs-carousel>
</div>